import { enablePatches, enableMapSet } from 'immer';

function run() {
    // Refer to Immer documentation if you wish to only import some parts of Immer.
    // See:
    //  https://immerjs.github.io/immer/docs/installation#pick-your-immer-version
    enablePatches();
    enableMapSet();
}

export default { run };
